<template>
  <div class="container1">
    <!-- 瀑布流列表 -->
    <div class="atlasList">
      <waterfall :col="2" :data="pictureList" @finish="finish">
        <template>
          <div
            class="pr"
            :style="radiusFlag ? 'border-radius: 6px;' : 'border-radius: 0px;'"
            v-for="(item, index) in pictureList"
            :key="order_id ? item.id : item.idorder_id"
            @click="toDetail(item,index)"
          >
            <div class="pr_item">
              <!-- <img :lazy-src="item.albumphotos" alt="加载错误" /> -->
              <img :src="item.albumphotos" alt="加载错误" />
              <div class="fenshu" v-if="grade"
                >总评分:{{ item.grade ? item.grade : "未评" }}</div
              >
              <slot name="text" :item="item"></slot>
              <div class="text" v-if="textFlag">
                <span class="textOver">{{ item.video_name }}</span>
                <div class="userInfo" v-if="userText">
                  <span class="user">{{ item.signup_username }}</span>
                  <div class="userimg">
                    <img src="@/assets/images/zans.png" alt="" />
                    <span>{{ item.triplikes }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </waterfall>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    pictureList: {
      type: Array,
    },
    //是否圆角
    radiusFlag: {
      type: Boolean,
      default() {
        return false;
      },
    },
    // 是否显示描述
    textFlag: {
      type: Boolean,
      default() {
        return false;
      },
    },
    //是否开启user字段
    userText: {
      type: Boolean,
      default() {
        return false;
      },
    },
    //是否开启order_id
    order_id: {
      type: Boolean,
      default() {
        return false;
      },
    },
    //是否开启评分数
    grade: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  data() {
    return {};
  },
  methods: {
    toDetail(item,index) {
      this.$emit("toDetail", item,index);
    },
    // 渲染列表完成事件
    finish() {
      this.$emit("finish");
    },
  },
};
</script>
<style scoped>
#vueWaterfall {
  padding: 0 6px;
}
.pr {
  padding: 0px;
  overflow: hidden;
  box-sizing: border-box;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
  background-color: #fff;
  margin: 0 4px;
  margin-bottom: 10px;
  /* border-radius: 6px; */
  position: relative;
}
.pr img {
  width: 100%;
  height: auto;
  display: block;
}
.pr_item .text {
  padding: 2px 4px;
}
.pr_item{
  position: relative;
}
.pr_item span {
  width: 100%;
  font-size: 14px;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.pr_item .user {
  color: #666;
  font-size: 12px;
  margin-top: 2px;
}
.userInfo {
  display: flex;
  flex: 1;
}
.userimg {
  display: flex;
  align-items: center;
}
.userimg img {
  width: 14px;
  height: 14px;
  margin-right: 2px;
}
.fenshu {
  font-size: 16px !important;
  color: #fa6c0e;
  position: absolute;
  right: 3%;
  top: 2%;
}
</style>